import Config from '../Config';
import { RestService } from './RestService';
import moment from 'moment';
import {format, format_without_time} from '../Utils';

export const PaymentService = {
    markCollected: async function(body) {
        return RestService.post(`${Config.update_payment}`, {}, body);
    },
    getTotalCount: async function(startDate, endDate){
        return RestService.get(`${Config.total_count}data_type=PAYMENT_TRANSACTIONS&startdate=${moment(startDate).format(format)}&enddate=${moment(endDate).format(format)}`, {})
        .then(response => response.json());
    },
    getTransactions: async function(start, numberItems, startdate, enddate, store, status, type, sort, direction) {
        return RestService.get(`${Config.get_payment_transactions}from=${start}&offset=${numberItems}&startdate=${moment(startdate).format(format_without_time)}&enddate=${moment(enddate).format(format_without_time)}${store.length > 0 ? `&store=${store}` : ''}${status.length > 0 ? `&status=${status}` : ''}${type.length > 0 ? `&type=${type}` : ''}&sort=${sort}&direction=${direction}`, {})
        .then(response => response.json());
    },
    getExportData: async function(startdate, enddate, store, status, type) {
        return RestService.get(`${Config.get_payment_transactions}export=true&startdate=${moment(startdate).format(format_without_time)}&enddate=${moment(enddate).format(format_without_time)}${store.length > 0 ? `&store=${store}` : ''}${status.length > 0 ? `&status=${status}` : ''}${type.length > 0 ? `&type=${type}` : ''}`, {})
        .then(response => response.json());
    },
};